import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

if (environment.marketplace) {
  document.getElementById('indexTitle').textContent = "Cuponeala";
  document.getElementById('favicon').setAttribute("href", "assets/images/favicon.ico");
} else {
  document.getElementById('indexTitle').textContent = "Alax";
  document.getElementById('favicon').setAttribute("href", "assets/images/alax-favicon.png");
}

declare global {
  interface Window {
    botpress?: any;
  }
}

// see: https://botpress.com/docs/webchat/interact/send-custom-events/to-webchat#with-embedded-webchat 
if (localStorage.getItem("token") && localStorage.getItem("permissions")) {
  if (localStorage.getItem("permissions").includes("WEBCHAT", 1)) {
    console.log(window.botpress.botId);
    if (!window.botpress.botId) {
      startBotpress();      
    }
  }
}

function startBotpress() {
  window.botpress.init({
    botId: "6509d982-9be6-4567-af27-a8c54db2ea92",
    messagingUrl: "https://messaging.botpress.cloud",
    clientId: "2398c088-16de-472c-b4bb-74166e9af66a",
    configuration: {
      "version": "v2",
      "botName": "Alex",
      "composerPlaceholder": "Escribí tu mensaje...",
      "phone": {},
      "additionalStylesheet": ".bpModalTitle {visibility: hidden;} .bpModalTitle::after { visibility: visible; content: 'Ayudanos a mejorar'; position: absolute; } .bpModalButtonConfirm { visibility: hidden; } .bpModalButtonConfirm::after { visibility: visible; content: 'Enviar'; position: absolute; left: 0; width: 100%; padding: var(--bpSpacing-3); border-radius: calc(var(--bpRadius-scale) * var(--bpRadius-md)); color: var(--message-text); font-size: .875rem; line-height: 1.25rem; background: var(--modal-submit-bg); cursor:pointer; } .bpModalButtonCancel { visibility: hidden; } .bpModalButtonCancel::after {     visibility: visible; content: 'Cancelar'; position: absolute; width: 100%; left: 0; padding: var(--bpSpacing-3); border-radius: calc(var(--bpRadius-scale) * var(--bpRadius-md)); color: var(--bpGray-900); font-size: .875rem; line-height: 1.25rem; background: var(--bpGray-100); cursor:pointer; } ",
      "showPoweredBy": false,
      "variant": "soft",
      "themeMode": "light",
      "fontFamily": "inter",
      "botAvatar": "assets/images/alex-avatar.jpg",
      "color": "#0033ff",
      "footer": "",
      "feedbackEnabled": true
    }
  }); // bot style config: https://botpress.com/docs/webchat/react-library/components/webchat#param-configuration

  window.botpress.on('webchat:ready', () => {
    console.log("bot inicializado en main");
    // console.log(window.botpress);
    var userName = localStorage.getItem("nombre") != "null" ? localStorage.getItem("nombre") : localStorage.getItem("razon_social");
    window.botpress.updateUser({
      name: userName
    });

    var botElm = document.querySelector<HTMLElement>('.bpFabWrapper')!;
    if (botElm) {
      console.log(botElm);
      const childElements = botElm.getElementsByClassName('bpModalContentTextArea');
      console.log(childElements); 
    }

    


    //setTimeout(() => {
      // IF: 
      // - we are at the last 15 days of the month
      // - and haven't send a proactive message this month 
      // send it
      var today = new Date();
      if (today.getDate() >= 15) { // test: 1 xq es el primero
        var lastTime = localStorage.getItem("webchat_proactive");
        if (lastTime) {
          var lastTimeDate = new Date(lastTime);
          if ((today.getMonth() + 1) != (lastTimeDate.getMonth() + 1)) {
            window.botpress.sendEvent({"proactive_alert": "true"});
            console.log("mandé evento proactivo");
            localStorage.setItem("webchat_proactive", today.toISOString());
            setTimeout(() => { window.botpress.open() }, 4000);
          }
        } else {
          window.botpress.sendEvent({"proactive_alert": "true"});
          console.log("mandé evento proactivo");
          localStorage.setItem("webchat_proactive", today.toISOString());
          setTimeout(() => { window.botpress.open() }, 4000);
        } 
      }
    //}, 10000);
  });
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
};


if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}

